export function initPostGrid() {
    document.addEventListener('click', (e) => {
        const btn = e.target.closest('.js-load-more');
        if (!btn) return;

        const grid = document.getElementById('post-grid-items');
        if (!grid) return;

        const page  = parseInt(btn.dataset.page, 10) + 1;
        const count = parseInt(btn.dataset.count, 10);
        const total = parseInt(btn.dataset.total, 10);

        btn.disabled = true;
        btn.classList.add('is-loading');

        const body = new URLSearchParams({
            action: 'post_grid_load_more',
            nonce:  ajax_object.nonce,
            page,
            count,
        });

        fetch(ajax_object.ajax_url, { method: 'POST', body })
            .then((r) => r.json())
            .then(({ success, data }) => {
                if (!success) return;

                grid.insertAdjacentHTML('beforeend', data.html);
                btn.dataset.page = page;

                if (!data.has_more || page >= total) {
                    btn.remove();
                } else {
                    btn.disabled = false;
                    btn.classList.remove('is-loading');
                }
            })
            .catch(() => {
                btn.disabled = false;
                btn.classList.remove('is-loading');
            });
    });
}
